import api from '@/api/api';
import Product from '../models/Product';

const state = {
  utilized: [],
  loaded: false,
};

const getters = {};

const mutations = {
  set_utilized: (state, payload) => {
    state.utilized = payload;
  },

  set_loaded: (state, payload) => {
    state.loaded = payload;
  },
};

const actions = {

  utset_loaded: (context, payload) => {
    context.commit('set_loaded', payload);
  },

  ututilized_list: (context) => {
    api().get(`${context.getters.get_app_section}/products/utilized_list`)
      .then((resp) => resp.data)
      .then((data) => data.map((group) => group.map((product) => new Product(product))))
      .then((list) => context.commit('set_utilized', list))
      .then(() => context.commit('set_loaded', true))
      .catch((error) => {
        console.error('Error:', error);
        context.commit('set_loaded', null);
      });
  },

};

export default {
  state,
  getters,
  mutations,
  actions,
};
